import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, renderList as _renderList, vModelSelect as _vModelSelect, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "text-center" }
const _hoisted_2 = ["placeholder"]
const _hoisted_3 = { class: "font-weight-bold" }
const _hoisted_4 = {
  key: 0,
  class: "mt-8"
}
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "mt-8 text-center" }
const _hoisted_7 = {
  key: 0,
  class: "mt-8"
}

import {computed, getCurrentInstance, ref} from 'vue';
import {IWidgetPaymentTabContent, SUM_TYPE_CLIENT, SUM_TYPE_FIXED, SUM_TYPE_LIST} from "~/chat/ts/data/ITab";
import Htmlify from "~/chat/vue/misc/ChatHtmlify.vue";
import ChatFormButton from "~/chat/vue/widget/form/fields/ChatFormButton.vue";
import ChatApiRequest from "~/chat/ts/service/request/ChatApiRequest";
import {IPaymentParamsFromOperator} from "~/chat/vue/widget/tabs/payment/PaymentFormInterface";
import {__} from "~/ts/library/Translate";


const __default__ = {
    name: "PaymentSumSelector"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    content: {},
    paramsFromOperator: {}
  },
  emits: ["input"],
  setup(__props: any, { emit: __emit }) {

let props = __props;

let emits = __emit;

let clientSum = ref<number>();
let listSum = ref("");
let showLoad = ref(false);

let operatorPaymentSum = computed<number>(() => {
    if (props.paramsFromOperator) {
        return props.paramsFromOperator.paymentSum;
    }
    return null;
});

let sumFixed = computed(() => {
    return operatorPaymentSum.value ? operatorPaymentSum.value : props.content.sumFixed;
});

let sumType = computed(() => {
    let sumType = props.content.sumType;
    if (operatorPaymentSum.value) {
        sumType = SUM_TYPE_FIXED;
    }
    return sumType;
});


let value = computed<number>(() => {
    let value = null;
    if (sumType.value === SUM_TYPE_CLIENT) {
        value = clientSum.value;
    } else if (sumType.value === SUM_TYPE_FIXED) {
        value = sumFixed.value;
    } else if (sumType.value === SUM_TYPE_LIST) {
        value = parseInt(listSum.value);
    }
    return value;
});

let instance = getCurrentInstance().proxy;

async function emitInput() {
    showLoad.value = true;
    if (value.value > 0) {
        try {
            let result = await ChatApiRequest.make({
                method: "createBillByClient",
                p: {
                    sum: value.value
                }
            });
            if (!result.isSuccess()) {
                result.showMessage(instance);
            } else {
                emits("input", result.getParam("id"));
            }
        } catch (e) {

        }
    }
    showLoad.value = false;
}

let isDisabled = computed(() => {
    return !value.value;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(Htmlify, {
      escape: false,
      value: _ctx.content.html
    }, null, 8, ["value"]),
    _createElementVNode("div", _hoisted_1, [
      (_unref(sumType) === 'client')
        ? _withDirectives((_openBlock(), _createElementBlock("input", {
            key: 0,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(clientSum) ? (clientSum).value = $event : clientSum = $event)),
            placeholder: `${_unref(__)('ENTER_PAYMENT_SUM')} (${_ctx.content.currency.short_descr})`,
            type: "number",
            step: "0.01"
          }, null, 8, _hoisted_2)), [
            [
              _vModelText,
              _unref(clientSum),
              void 0,
              { number: true }
            ]
          ])
        : _createCommentVNode("", true),
      (_unref(sumType) === 'fixed')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createTextVNode(_toDisplayString(_unref(__)("PAYMENT_SUM")) + ": ", 1),
            _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(sumFixed)) + " " + _toDisplayString(_ctx.content.currency.short_descr), 1),
            (_ctx.paramsFromOperator && _ctx.paramsFromOperator.paymentComment)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.paramsFromOperator.paymentComment), 1))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true),
      (_unref(sumType) === 'list')
        ? _withDirectives((_openBlock(), _createElementBlock("select", {
            key: 2,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(listSum) ? (listSum).value = $event : listSum = $event))
          }, [
            _cache[2] || (_cache[2] = _createElementVNode("option", { value: "" }, "Выберите сумму платежа", -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.content.sumList, (item, index) => {
              return (_openBlock(), _createElementBlock("option", {
                key: index,
                value: item[0]
              }, _toDisplayString(item[1] ? item[1] : `${item[0]} ${_ctx.content.currency.short_descr}`), 9, _hoisted_5))
            }), 128))
          ], 512)), [
            [_vModelSelect, _unref(listSum)]
          ])
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(ChatFormButton, {
        disabled: _unref(isDisabled),
        "show-load": _unref(showLoad),
        type: "primary",
        onClick: emitInput
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(__)("CONTINUE")), 1)
        ]),
        _: 1
      }, 8, ["disabled", "show-load"])
    ]),
    (_ctx.content.html_footer && _ctx.content.html_footer.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createVNode(Htmlify, {
            escape: false,
            value: _ctx.content.html_footer
          }, null, 8, ["value"])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})